// @ts-nocheck
import React from 'react';

import {
  capitalRoutingSection,
  knowledgeHubSection,
  marketplaceBrand,
  trustEngineSection,
} from '../../config/marketplaceContent';
import { useTheme } from '../../context/ThemeContext';

import css from './LandingNarrative.module.css';

const LandingNarrative: React.FC = () => {
  const { isDark } = useTheme();

  return (
    <div className={isDark ? css.root : css.rootLight}>
      <section className={css.hero} id={marketplaceBrand.tagline.replace(/\s+/g, '-').toLowerCase()}>
        <p className={css.eyebrow}>{marketplaceBrand.heroEyebrow}</p>
        <h1 className={css.heroTitle}>{marketplaceBrand.heroTitle}</h1>
        <p className={css.heroSubtitle}>{marketplaceBrand.heroSubtitle}</p>
      </section>

      <section className={css.section} id={trustEngineSection.id} aria-labelledby="trust-engine-title">
        <div className={css.sectionHeader}>
          <h2 id="trust-engine-title" className={css.sectionTitle}>
            {trustEngineSection.title}
          </h2>
          <p className={css.sectionSubtitle}>{trustEngineSection.subtitle}</p>
        </div>
        <div className={css.stepGrid}>
          {trustEngineSection.steps.map((step, index) => (
            <article key={step.id} className={css.stepCard}>
              <span className={css.stepIndex}>{index + 1}</span>
              <h3 className={css.stepLabel}>{step.label}</h3>
              <p className={css.stepBody}>{step.body}</p>
            </article>
          ))}
        </div>
      </section>

      <section className={css.section} id={capitalRoutingSection.id} aria-labelledby="capital-routing-title">
        <div className={css.sectionHeader}>
          <h2 id="capital-routing-title" className={css.sectionTitle}>
            {capitalRoutingSection.title}
          </h2>
          <p className={css.sectionSubtitle}>{capitalRoutingSection.subtitle}</p>
        </div>
        <div className={css.routingFlow}>
          {capitalRoutingSection.steps.map((step, index) => (
            <React.Fragment key={step.id}>
              <article className={css.routingNode}>
                <h3 className={css.routingLabel}>{step.label}</h3>
                <p className={css.routingBody}>{step.body}</p>
              </article>
              {index < capitalRoutingSection.steps.length - 1 ? (
                <div className={css.routingArrow} aria-hidden="true">
                  →
                </div>
              ) : null}
            </React.Fragment>
          ))}
        </div>
      </section>

      <section className={css.section} id={knowledgeHubSection.id} aria-labelledby="knowledge-hub-title">
        <div className={css.sectionHeader}>
          <h2 id="knowledge-hub-title" className={css.sectionTitle}>
            {knowledgeHubSection.title}
          </h2>
          <p className={css.sectionSubtitle}>{knowledgeHubSection.subtitle}</p>
        </div>
        <div className={css.tileGrid}>
          {knowledgeHubSection.tiles.map(tile => (
            <article key={tile.id} className={css.tile}>
              <span className={css.tileTag}>{tile.tag}</span>
              <h3 className={css.tileTitle}>{tile.title}</h3>
              <p className={css.tileSummary}>{tile.summary}</p>
            </article>
          ))}
        </div>
      </section>
    </div>
  );
};

export default LandingNarrative;
